import React from 'react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] text-gray-500 py-8 text-center text-sm border-t border-[#2D2D2D]" data-id="element-44">
      <div className="max-w-6xl mx-auto px-4" data-id="element-45">
        <p data-id="element-46">© 2026 Kit DM Que Cierra. Todos los derechos reservados.</p>
      </div>
    </footer>;
}